import {createAction, handleActions} from 'redux-actions';
import { actions as labelCollection} from './labelCollection';
import * as api from '../services/api';
import _ from 'lodash';

// regular actions
const SET = '@translationtool/languages/SET';
const SELECT = '@translationtool/languages/SELECT';
const RESET_SELECTED = '@translationtool/languages/RESET_SELECTED';
const REMOVE = '@translationtool/languages/REMOVE';
const SET_LOADING = '@translationtool/languages/SET_LOADING';
const REMOVE_LOADING = '@translationtool/languages/REMOVE_LOADING';
const SET_CLICKED_SAVE_LANGUAGE = '@translationtool/languages/SET_CLICKED_SAVE_LANGUAGE';
const REMOVE_CLICKED_SAVE_LANGUAGE = '@translationtool/languages/REMOVE_CLICKED_SAVE_LANGUAGE';

const set  = createAction(SET, languages => languages);
const select  = createAction(SELECT, language => language);
const resetSelected  = createAction(RESET_SELECTED);
const remove  = createAction(REMOVE, language => language);
const setLoading = createAction(SET_LOADING, language => language);
const removeLoading = createAction(REMOVE_LOADING, language => language);
const setClickedSaveLoading = createAction(SET_CLICKED_SAVE_LANGUAGE, language => language);
const removeClickedSaveLoading = createAction(REMOVE_CLICKED_SAVE_LANGUAGE, language => language);

export const reducer = handleActions(
	{
		[SET]: (state, action) => {
			return {...state, languages: action.payload};
		},
		[SELECT]: (state, action) => {
			return {...state, selected: action.payload};
		},
		[RESET_SELECTED]: (state) => {
			return {...state, selected: null};
		},
		[REMOVE]: (state, action) => {
			return {...state, languages: _.without(state.languages, action.payload)};
		},
        [SET_LOADING]: (state, action) => {
            return {...state, loadingLanguages: _.concat(state.loadingLanguages, action.payload)};
        },
        [REMOVE_LOADING]: (state, action) => {
		    let newArray = [...state.loadingLanguages];
		    let indexOf = newArray.indexOf(action.payload)
            newArray.splice(indexOf, 1)
            return {...state, loadingLanguages: newArray};
        },
        [SET_CLICKED_SAVE_LANGUAGE]: (state, action) => {
            return {...state, clickedSaveLanguage: _.concat(state.clickedSaveLanguage, action.payload)};
        },
        [REMOVE_CLICKED_SAVE_LANGUAGE]: (state, action) => {
            let newArray = [...state.clickedSaveLanguage];
            let indexOf = newArray.indexOf(action.payload)
            newArray.splice(indexOf, 1)
            return {...state, clickedSaveLanguage: newArray};
        },
	},
	{
		languages: [],
		selected: null,
        loadingLanguages: [],
        clickedSaveLanguage: []
	}
);

// thunks
const selectWrapper = (identifier) => (dispatch, getState) => {
	const getLanguage = () => _.find(getState().language.languages, {identifier});

	if(getState().language.languages.length){
		dispatch(select(getLanguage()));
	} else {
		dispatch(fetch()).then(() => dispatch(select(getLanguage())));
	}
};

const fetch = () => (dispatch) => {
	return api.handleFetch(
		() => api.fetchLanguages(),
		dispatch,
		languages => dispatch(set(languages)),
		'No languages found'
	);
};

const create = (language) => (dispatch) => {
	return api.handleUpdate(
		() => api.createLanguage(language),
		dispatch,
		() => dispatch(fetch())
	);
};

const update = (language) => (dispatch, getState) => {
	const identifier = getState().language.selected.identifier;
	return api.handleUpdate(
		() => api.updateLanguage(encodeURIComponent(identifier), language),
		dispatch,
		() => dispatch(fetch())
	);
};

const deleteLanguage = (language) => (dispatch) => {
	return api.handleUpdate(
		() => api.deleteLanguage(encodeURIComponent(language.identifier)),
		dispatch,
		() => dispatch(remove(language))
	);
};

const removeLoadingWrapper = (language) => (dispatch, getState) => {
    dispatch(removeLoading(language))
    if (getState().language.clickedSaveLanguage.includes(language)){
        dispatch(labelCollection.finishLanguage(language))
        dispatch(removeClickedSaveLoading(language))
    }
};

// public actions
export const actions = {
	fetch,
	create,
	update,
	delete: deleteLanguage,
	select: selectWrapper,
	resetSelected,
    setLoading,
    removeLoading: removeLoadingWrapper,
    setClickedSaveLoading,
    removeClickedSaveLoading
};



// WEBPACK FOOTER //
// ./React/src/reducers/language.js